import { render, staticRenderFns } from "./cpt-not-vip.vue?vue&type=template&id=5f9251a1&scoped=true&"
import script from "./cpt-not-vip.vue?vue&type=script&lang=js&"
export * from "./cpt-not-vip.vue?vue&type=script&lang=js&"
import style0 from "./cpt-not-vip.vue?vue&type=style&index=0&id=5f9251a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9251a1",
  null
  
)

export default component.exports